export type QueryOptions = {
    enabled?: boolean
    refetchInterval?: number
}

export const defaultOptions: QueryOptions = {
    enabled: true,
}
